export const fastlyUrl = (url: string, width: number): string => {
    const widthString = width ? `&width=${width}` : ''
    return `${url}?auto=webp&format=pjpg&crop=1:1${widthString}`
}
